/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B100183 WH単価マスタ出力
 */
import { Box } from "@mui/material";
import {
  B100183ExcelRequest,
  B100183GetExcel,
  catchFileError,
  B000111WhgentankaNmFrom,
  B000111WhgentankaNmTo,
} from "clients/rest";
import {
  msgState,
  SCodeSelect,
  SConfirmDialog,
  SFileButton,
  SFrame,
  SLabel,
  SNumberField,
  SText,
  STextField,
} from "components";
import { getClientMessage } from "messages";
import { getSCode, SCode, WhTankaKbn } from "messages/codes";
import { labels } from "messages/labels";
import { B000111 } from "pages";
import { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { download } from "services";
import { meishoKbn } from "services/codes";
import { focusState, useFocus } from "states";

// 呼び出し時のプロパティ
type Props = Partial<{}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  whtankaKbn: SCode;
  whtankaCdFrom: string;
  whtankaNmFrom: string;
  whtankaCdTo: string;
  whtankaNmTo: string;
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  whtankaKbn: getSCode(WhTankaKbn, "0"),
  whtankaCdFrom: "",
  whtankaNmFrom: "",
  whtankaCdTo: "",
  whtankaNmTo: "",
};

const focusId = "B100183";

export const B100183 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  // 状態管理の初期設定
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });
  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));
  // 画面遷移
  const navigate = useNavigate();
  // エラー表示
  const setMsg = useSetRecoilState(msgState);

  // 初期表示イベント
  useEffect(() => {
    // 初回フォーカス先
    focus(1);
  }, []);

  // EXCELボタン押下時
  const handleClickExcelButton = () => {
    const fields = methods.getValues();

    const param: B100183ExcelRequest = {
      whtankaKbn: fields.whtankaKbn?.value,
      whtankaCdFrom: fields.whtankaCdFrom!,
      whtankaCdTo: fields.whtankaCdTo!,
    };

    B100183GetExcel(param)
      .then((response) => {
        download(response);
        setMsg(getClientMessage("B100183_001"));
      })
      .catch((reason) => {
        catchFileError(reason, navigate, setMsg);
      });
  };

  // レイアウト設定
  return (
    <FormProvider {...methods}>
      <SFrame
        title="WH単価マスタ出力"
        gridTemplateColumns="7rem 7rem 10rem 1rem 7rem 10rem 5rem"
      >
        <SText gridColumn="span 7">　</SText>

        <SLabel gridColumn="1" required>
          WH単価区分
        </SLabel>
        <SCodeSelect
          required
          label="WH単価区分"
          name="whtankaKbn"
          options={WhTankaKbn}
          {...register(1)}
        />

        <SLabel gridColumn="1" required>
          WH単価
        </SLabel>
        <SNumberField
          required
          label="WH単価コード(開始)"
          name="whtankaCdFrom"
          code
          size={4}
          {...register(2)}
          dialog={<B000111 meishoKbn={meishoKbn.whTanka} />}
          handleSubmit={(data: any) => {
            methods.setValue("whtankaCdFrom", data.meishoCd);
            methods.setValue("whtankaNmFrom", data.meishoNm1);
          }}
          onBlur={() => B000111WhgentankaNmFrom(methods, navigate, setMsg)}
        />
        <STextField required name="whtankaNmFrom" disabled />
        <SText>～</SText>
        <SNumberField
          name="whtankaCdTo"
          code
          size={4}
          {...register(3)}
          dialog={<B000111 meishoKbn={meishoKbn.whTanka} />}
          handleSubmit={(data: any) => {
            methods.setValue("whtankaCdTo", data.meishoCd);
            methods.setValue("whtankaNmTo", data.meishoNm1);
          }}
          onBlur={() => B000111WhgentankaNmTo(methods, navigate, setMsg)}
        />
        <STextField name="whtankaNmTo" disabled />
        <Box />

        <SText gridColumn="span 7">　</SText>
        <SText gridColumn="span 7">　</SText>
        <SText gridColumn="span 7">　</SText>

        <Box gridColumn="span 5" />
        <SFileButton
          label={labels.buttons.excel}
          align="right"
          {...register(4)}
          dialog={
            <SConfirmDialog
              title="WH単価マスタ出力"
              msg={labels.dialog.masterExcelConfirmMessage}
            />
          }
          dialogAction="confirm"
          handleSubmit={handleClickExcelButton}
        />
      </SFrame>
    </FormProvider>
  );
};
